module.exports = __webpack_public_path__ + "fonts/19727012e68dbe5cca7e416c41ae7f3a.woff2";